import {madnes_fill_range, madnes_join} from "../framework/src/engine/madnes/madnes";

var in_smoke_pos = 0;
var lines = new Array();

var render_move_per_sec = 16; // Symbolu za sekundu
var render_move_per_sec_free = 26; // Symbolu za sekundu ve free spinu

export var cylinder_pos = new Array();
cylinder_pos[0] = 26;
cylinder_pos[1] = 330;
cylinder_pos[2] = 634;
cylinder_pos[3] = 936;

var freepanelpos = 200;

export var icons = {
    "symbol_Bell": {
        stop: [25],
        anim: madnes_join( madnes_join( madnes_join( [25, 25, 25, 25, 25], madnes_fill_range(25, 32) ), madnes_join( madnes_fill_range(10, 24), madnes_fill_range(10, 24) ) ), madnes_join( madnes_fill_range(0, 9), 25) ),
        start: madnes_join( [25, 25, 25, 25, 25], madnes_fill_range(25, 32) ),
        end: madnes_join( madnes_fill_range(0, 9), 25),
        loop: madnes_join( madnes_fill_range(10, 24), madnes_fill_range(10, 24) )
    },
    "symbol_Grape":  {
        stop: [30],
        anim: madnes_join( madnes_join( madnes_join( [30, 30, 30, 30, 30], madnes_fill_range(30, 59) ), madnes_fill_range(15, 29) ), madnes_join( madnes_fill_range(0, 14), 30) ),
        start: madnes_join( [30, 30, 30, 30, 30], madnes_fill_range(30, 59) ),
        end: madnes_join( madnes_fill_range(0, 14), 30),
        loop: madnes_fill_range(15, 29)
    },
    "symbol_X2":	{
        stop: [0],
        anim: madnes_join(madnes_fill_range(0, 31), [0])
    },
    "symbol_X2_long":	{
        stop: [0],
        anim: madnes_join(madnes_fill_range(0, 59), [0])
    }
}

icons["symbol_Dollar"] = icons["symbol_Bell"];
icons["symbol_Cherry"] = icons["symbol_Bell"];
icons["symbol_Orange"] = icons["symbol_Bell"];
icons["symbol_Plum"] = icons["symbol_Bell"];
icons["symbol_Wild_short"] = icons["symbol_Bell"];

icons["symbol_Melon"] = icons["symbol_Grape"];
icons["symbol_Seven"] = icons["symbol_Grape"];
icons["symbol_Wild"] = icons["symbol_Grape"];

icons["symbol_X4"] = icons["symbol_X2"];
icons["symbol_X8"] = icons["symbol_X2"];

icons["symbol_X4_long"] = icons["symbol_X2_long"];
icons["symbol_X8_long"] = icons["symbol_X2_long"];

export var icons_tmp = new Array();

export var symbols = new Array();
symbols[0] = -1;
symbols[1] = -1;
symbols[2] = -1;
symbols[3] = -1;

export var last_symbol = new Array();
last_symbol[0] = -1;
last_symbol[1] = -1;
last_symbol[2] = -1;
last_symbol[3] = -1;

var reels_lenghts = new Array();
var reels_pos = new Array();

var img_laoder;

var diry = new Array();

var smoke_manager, smoke_emitter;

function init_game(dname, cfg)
{
    // madnes_load_init("multi_vegas_81", cfg);
    //
    // madnes_set_page_bg(dname, imgsPath + "web/background.png");
    //
    // madnes_set_texture_version(8);

    // madnes_set_ico_size(200, 184);
    // madnes_set_win_factors(25, 50, 125);
    // madnes_set_native_sceen_size(1280, 720);

    //madnes_set_on_rotate_click("button_click");

    // for(var i in to_load_json)
    // {
    //     if(infotexts_languages.indexOf(lang) === -1)
    //     {
    //         to_load_json[i] = to_load_json[i].replace("{l}", def_lang);
    //     }
    //
    //     madnes_add_json(i, to_load_json[i]);
    // }
    //
    // for(var i in to_load_audio)
    // {
    // 	madnes_add_audio(i, to_load_audio[i]);
    // }
    //
    // for(var i in to_load)
    // {
    // 	madnes_add_to_load(i, to_load[i]);
    // }
    //
    // for(var i in to_load_fonts)
    // {
    // 	madnes_add_font_to_load(i, to_load_fonts[i]);
    // }

    // //madnes_set_sprite('_sprite', 382, 382);
    // madnes_set_sprite('_sprite', 320, 280);
    //
    // //madnes_set_sprite('_blur', 382, 382);
    // madnes_set_sprite('_blur', 320, 280);
    //
    // madnes_set_sprite('bigwin_sprite', 758, 510);
    //
    // madnes_set_default_volume(0.8);
    // madnes_set_audio_volume("reel", 0.6);

    madnes_set_printdesk_function(mv81_print_desk);
    madnes_set_updatedesk_function(mv81_print_reels);
    madnes_set_rotate_function(mv81_rotate_run);

    madnes_set_infomenu_init_function(mv81_infomenu_init);
    madnes_set_infomenu_open_function(mv81_infomenu_open);
    madnes_set_infomenu_close_function(mv81_infomenu_close);
    madnes_set_infomenu_update_function(mv81_infomenu_update);
    madnes_set_infomenu_left_function(mv81_infomenu_left);
    madnes_set_infomenu_right_function(mv81_infomenu_right);

    madnes_set_coin_values_init(function(currency)
    {
        if(currency === "PLN")
        {
            coin_values = [0.1, 1];
        }
        else
        {
            madnes_coin_values_init(currency);
        }
    });

    madnes_set_on_rotate_release(rotate_release);
    madnes_set_on_forcestop_press(forcestop_press);

    madnes_init(dname);
}

